import React from "react";
import { Box, Typography, useTheme, Card, Button } from "@mui/material";
import GridContainer from "../../components/grid/GridContainer.jsx";
import GridItem from "../../components/grid/GridItem.jsx";
import { getLeranMoreStyle } from "../../components/customstyles/LearnMoreStyle.jsx";
import { useRouteMatch, useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

const useStyles = () => {
  let theme = useTheme();
  return getLeranMoreStyle(theme);
};

function LearnMore(props) {
  const styles = useStyles();
  const match = useRouteMatch();
  const history = useHistory();

  const learnMoreCardData = [
    {
      heading: "About the Assessment",
      link: `/patients/${match.params.patientId}/2/aboutassessment`,
      content:
        "Learn about the two parallel processes required for AIMS, scoring the severity of observed movements, and important steps before you begin the examination procedure.",
    },
    {
      heading: "Body Areas",
      link: `/patients/${match.params.patientId}/2/bodyareas`,
      content:
        "Learn about the key body areas that are observed during the AIMS assessment and their associated movement ratings.",
    },
    {
      heading: "Global Judgments",
      link: `/patients/${match.params.patientId}/2/globaljudgments`,
      content:
        "Learn about assessing the overall severity of movements and their impact on the patient's life.",
    },
    {
      heading: "Dental Status",
      link: `/patients/${match.params.patientId}/2/dentalstatus`,
      content:
        "Learn how the patient’s dental status can impact the AIMS assessment.",
    },
  ];
  return (
    <div className="FSUnmask">
      <Helmet>
        <title>Patient Details</title>
      </Helmet>
      <Box sx={{ marginTop: "20px" }}>
        <GridContainer>
          {learnMoreCardData.map((item) => {
            return (
              <GridItem
                lg={6}
                md={6}
                sm={6}
                xs={6}
                sx={styles.gridAlign}
                key={item.heading}
              >
                <Card sx={styles.cardStyle}>
                  <Typography sx={styles.cardHeadingStyle}>
                    {item.heading}
                  </Typography>
                  <Typography sx={styles.cardContentStyle}>
                    {item.content}
                  </Typography>
                  <Box sx={styles.btnBoxStyle}>
                    <Button
                      variant="contained"
                      onClick={() => history.push(item.link)}
                      sx={styles.readArticlebtnStyle}
                    >
                      Learn More
                    </Button>
                  </Box>
                </Card>
              </GridItem>
            );
          })}
        </GridContainer>
      </Box>
    </div>
  );
}

export default LearnMore;
